import emojiRegex from 'emoji-regex';
import { EmojiIndex } from 'emoji-mart-vue-fast';
import { decodeEmojis } from '@getaccept/utils';
import type { Emoji } from '@getaccept/fried-tofu';
import { CUSTOM_EMOJI_LIST } from '../constants/emoji.constants';
import bugsnagClient from '../../bugsnag';
export class EmojiHelper {
  static async emojiIndex(customEmojis: Emoji[] = []): Promise<EmojiIndex> {
    const data = await import(
      /* webpackChunkName: 'emoji-data' */ 'emoji-mart-vue-fast/data/apple.json'
    );
    let custom: Emoji[] = CUSTOM_EMOJI_LIST;
    if (customEmojis.length > 0) {
      custom = custom.concat(customEmojis);
    }
    return new EmojiIndex(data.default, { custom });
  }

  static encode(text: string): string {
    const unicodeEmojiRegex = emojiRegex();
    const emojis: string[] = text.match(unicodeEmojiRegex) || [];

    let encodedString: string = text;
    emojis.forEach((emoji: string) => {
      const encodedEmoji = `[[emoji ${encodeURIComponent(emoji)}]]`;
      encodedString = encodedString.replace(emoji, encodedEmoji);
    });
    return encodedString;
  }

  static decode(text: string): string {
    try {
      return decodeEmojis(text);
    } catch (e) {
      if (bugsnagClient) {
        bugsnagClient.notify(e);
      }
      return text;
    }
  }

  static getEmojiListByKey(text: string, emojiIndex: EmojiIndex): Emoji[] {
    if (!text) {
      return [];
    }
    return emojiIndex.search(text.replace(/:/g, '')) || [];
  }

  static getEmojiWithSkinTone(emoji: Emoji, skinTone: number): Emoji {
    return (emoji?._skins && emoji?._skins[skinTone - 1]) || emoji;
  }
}
